export default "__VITE_ASSET__viy$stQq__"